import { ltjsModule } from '../ltjsEnvironment';
export function getClosetAddress(co) {
    //
    // nullptr address
    //
    if (!co) {
        return 0;
    }
    //
    // if not an array, just return member variable
    //
    if (!Array.isArray(co)) {
        return co.getClosetAddress();
    }
    //
    // if array, tail recursion to produce array of elements closetAddress values
    //
    // tslint:disable-next-line:no-unbound-method
    return co.map(getClosetAddress);
}
export function getAddress(co) {
    //
    // nullptr address
    //
    if (!co) {
        return 0;
    }
    //
    // if single ClosetObject, return address
    //
    if (!Array.isArray(co)) {
        return ltjsModule.getClosetKey(co.getClosetAddress());
    }
    //
    // if array, return array of mapped indices to addresses
    //
    // tslint:disable-next-line:no-unbound-method
    return co.map(getAddress);
}
